import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';

class User extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		const { isLink, user, firstNameCutOff, className, style, history } = this.props;
		let name,
			link = '';
		if (user.lastName && user.firstName) {
			name = `${firstNameCutOff ? `${user.firstName.charAt(0)}.` : user.firstName} ${user.lastName}`;
			link = `/app/user/${user.userId}`;
		} else if (user.group && user.group.groupId && user.group.name) {
			name = user.group.name;
			link = `/app/group/${user.group.groupId}`;
		} else {
			name = user.organisation ? user.organisation.name : <IntlMessages id="common.undefined" />;
			link = user.organisation ? `/app/organisation/${user.organisation.organisationId}` : '#';
		}
		if (isLink)
			return (
				<span className={`text-blue pointer ${className}`} style={style} onClick={() => history.push(link)}>
					{name}
				</span>
			);
		return (
			<span className={className} style={style}>
				{name}
			</span>
		);
	}
}

export default withRouter(User);



// WEBPACK FOOTER //
// ./components/User/index.js